import { Typography } from "@mui/material";

const Bio = () => {
  return (
    <>
      <Typography variant="h4">Not a hacker, but a hacker</Typography>
      <Typography variant="h4">Finding flaws. Fixing futures.</Typography>
      <Typography variant="h6">
        I'm Keiichiro KIMURA, currently working as a product security engineer.
      </Typography>
      {/* <Typography variant="h6" sx={{ mt: 2 }}>
        This website is no longer updated, except for results/achievements
        before March 31, 2025.
      </Typography> */}
    </>
  );
};

export default Bio;
